import React from 'react'
import ContentLoader from 'react-content-loader'

const LoaderDetailed = ({ pageRange }) => {
    const height = 57 * (pageRange + 1)
    const body = new Array(pageRange + 1).fill(null).map((i, ind) => {
        const yStrip = ind ? (57 * ind + 15) + "" : "15"
        return (
          <React.Fragment key={ind}>
              {
                  ind ?
                    <>
                      <rect x="15" y={yStrip} rx="3" ry="3" width="300" height="15" />
                      <rect x="350" y={yStrip} rx="3" ry="3" width="80" height="15" />
                      <rect x="450" y={yStrip} rx="3" ry="3" width="120" height="15" />
                      <rect x="600" y={yStrip} rx="3" ry="3" width="80" height="23" />
                      <rect x="700" y={yStrip} rx="3" ry="3" width="40" height="23" />
                      <rect x="750" y={yStrip} rx="3" ry="3" width="40" height="23" />
                    </> :
                    <>
                      <rect x="15" y={yStrip} rx="3" ry="3" width="100" height="15" />
                      <rect x="350" y={yStrip} rx="3" ry="3" width="80" height="15" />
                      <rect x="450" y={yStrip} rx="3" ry="3" width="60" height="15" />
                      <rect x="600" y={yStrip} rx="3" ry="3" width="40" height="23" />
                      <rect x="700" y={yStrip} rx="3" ry="3" width="40" height="23" />
                      <rect x="750" y={yStrip} rx="3" ry="3" width="60" height="23" />
                    </>
              }
          </React.Fragment>
        )
    })

    return (
      <ContentLoader
        speed={2}
        width={890}
        height={height}
        viewBox={`0 0 890 ${height}`}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
          <>
              {body}
          </>
      </ContentLoader>
    )

}

export default LoaderDetailed